"use client";
//#region packages/@mantine/core/src/core/Box/get-style-object/get-style-object.ts
function getStyleObject(style, theme) {
	if (Array.isArray(style)) return [...style].reduce((acc, item) => ({
		...acc,
		...getStyleObject(item, theme)
	}), {});
	if (typeof style === "function") return style(theme);
	if (style == null) return {};
	return style;
}
//#endregion
export { getStyleObject };

//# sourceMappingURL=get-style-object.mjs.map